/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Size Chart Accordion
document.addEventListener('DOMContentLoaded', function () {
  console.log('Size Chart Accordion JS loaded');
  const wrappers = document.querySelectorAll('.table-wrapper');
  const accordions = [];
  let lastOpenedAccordion = null;

  wrappers.forEach(function (wrapper, idx) {
    const table = wrapper.querySelector('table');
    if (!table) return;

    const titleCell = table.querySelector('th[class$="chart__title"]');
    if (!titleCell) return;

    const accordion = document.createElement('div');
    accordion.className = 'chart-accordion';

    const header = document.createElement('button');
    header.className = 'chart-accordion__header';
    header.type = 'button';
    header.innerHTML = titleCell.textContent + ' <span class="chart-accordion__icon">+</span>';

    const content = document.createElement('div');
    content.className = 'chart-accordion__content';
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

    content.appendChild(table);

    accordion.appendChild(header);
    accordion.appendChild(content);
    wrapper.parentNode.insertBefore(accordion, wrapper);
    wrapper.remove();

    accordions.push({ header, content });

    header.addEventListener('click', function () {
      // Close last opened accordion if it's not this one
      if (lastOpenedAccordion && lastOpenedAccordion !== content) {
        lastOpenedAccordion.style.maxHeight = '0';
        lastOpenedAccordion.previousSibling.querySelector('.chart-accordion__icon').textContent = '+';
      }
      const isOpen = content.style.maxHeight !== '0px' && content.style.maxHeight !== '';
      if (isOpen) {
        content.style.maxHeight = '0';
        header.querySelector('.chart-accordion__icon').textContent = '+';
        lastOpenedAccordion = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        header.querySelector('.chart-accordion__icon').textContent = '−';
        lastOpenedAccordion = content;
      }
    });
  });

  // Preopen the last accordion after all are created
  if (accordions.length > 0) {
    const last = accordions[accordions.length - 1];
    last.content.style.maxHeight = last.content.scrollHeight + 'px';
    last.header.querySelector('.chart-accordion__icon').textContent = '−';
    lastOpenedAccordion = last.content;
  }
});

// product-variant-selector [Functionality to update stock indicator based on selected variant] [Ron]
document.addEventListener('DOMContentLoaded', function () {
    const stockIndicator = document.querySelector('[data-stock-indicator]');
    if (!stockIndicator) return;

    // Helper function to update stock indicator
    function updateStockIndicator(isInStock) {
        if (isInStock) {
            stockIndicator.innerHTML = `
                <span class="in-stock" style="color: #008800;">
                    <span style="display: inline-block; width: 12px; height: 12px; background-color: #00b300; border-radius: 50%; margin-right: 5px;"></span>
                    Stock available*
                </span>
            `;
        } else {
            stockIndicator.innerHTML = `
                <span class="out-of-stock" style="color: #880000;">
                    <span style="display: inline-block; width: 12px; height: 12px; background-color: #880000; border-radius: 50%; margin-right: 5px;"></span>
                    Out of Stock
                </span>
            `;
        }
    }

    // Initial check on page load
    function checkInitialVariant() {
        // First try to get selected variant from radio buttons
        const selectedBlockSwatch = document.querySelector('.block-swatch__radio:checked');
        const selectedColorSwatch = document.querySelector('.color-swatch__radio:checked');

        if (selectedBlockSwatch) {
            const parentSwatch = selectedBlockSwatch.closest('.block-swatch');
            updateStockIndicator(!parentSwatch.classList.contains('block-swatch--disabled'));
        } else if (selectedColorSwatch) {
            const parentSwatch = selectedColorSwatch.closest('.color-swatch');
            updateStockIndicator(!parentSwatch.classList.contains('color-swatch--disabled'));
        } else {
            // Fallback to check variant JSON
            const variantJson = document.querySelector('[data-variant-json]');
            if (variantJson) {
                try {
                    const variantData = JSON.parse(variantJson.textContent);
                    const selectedVariant = variantData.selected_variant || variantData.current_variant;
                    if (selectedVariant) {
                        updateStockIndicator(selectedVariant.available && selectedVariant.inventory_quantity > 1);
                    }
                } catch (e) {
                    console.error('Error parsing variant JSON:', e);
                }
            }
        }
    }

    // Run initial check
    checkInitialVariant();

    // Event listeners for block swatches
    document.querySelectorAll('.block-swatch__item, .block-swatch__radio').forEach(element => {
        const eventType = element.tagName === 'INPUT' ? 'change' : 'click';
        element.addEventListener(eventType, () => {
            setTimeout(() => {
                const parentSwatch = element.closest('.block-swatch');
                if (parentSwatch) {
                    updateStockIndicator(!parentSwatch.classList.contains('block-swatch--disabled'));
                }
            }, 10);
        });
    });

    // Event listeners for color swatches
    document.querySelectorAll('.color-swatch__item, .color-swatch__radio').forEach(element => {
        const eventType = element.tagName === 'INPUT' ? 'change' : 'click';
        element.addEventListener(eventType, () => {
            setTimeout(() => {
                const parentSwatch = element.closest('.color-swatch');
                if (parentSwatch) {
                    updateStockIndicator(!parentSwatch.classList.contains('color-swatch--disabled'));
                }
            }, 10);
        });
    });

    // Listen for variant change events
    document.addEventListener('variant:changed', function (event) {
        if (!event.detail.variant) return;
        updateStockIndicator(event.detail.variant.available && event.detail.variant.inventory_quantity > 1);
    });
});
